import React from "react";
import Welcome from "../master_pobox";
import apiUrl from "../enviroments/enviroment";
import axios from 'axios';
import swal from "sweetalert";

class MisContactos extends React.Component{

    state = {
        contactos: []
    };

    constructor(props) {
        super(props);
        this.state = {
            contactos: []
        }
    }

    componentDidMount() {
        let p_seccion = localStorage.getItem("seccion");
        axios.get(`${apiUrl.apiUrl}contactos/`+ p_seccion, {
            headers: {
                userid: 'transexpress',
                pwduser: 'JTOYV9IlFarK6G2jPRo7dJxkmfHOhD9S',
            }
        }).then(res => {
            //console.log(res.data[0]);
            this.setState({contactos: res.data});
        },(error) => {
            swal("Ayuda", "Ha ocurrido un error, contactate con el administrador del sitio web", "error");
        });
    }

    render(){
        return (
            <Welcome>
                <main id="js-page-content" role="main" className="page-content">
                    <div className="subheader">
                        <h1 className="subheader-title">
                            <i className="fal fa-info-circle"/> MIS CONTACTOS
                            <small>
                                Contactos
                            </small>
                        </h1>
                    </div>
                    <div className="fs-lg fw-300 p-5 bg-white border-faded rounded mb-g">
                        <div className="panel-content">
                            {this.state.contactos.map((gen) =>
                                <div className="col-sm-12 row">
                                    <div className="col-sm-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-sm-2">
                                                        <img src="src/img/ICONO-USUARIO.png" width="100%"/>
                                                    </div>
                                                    <div className="col-sm-8">
                                                        <h3><b>{gen.rol_contacto}</b></h3>
                                                        <h5><b>{gen.nombre} , {gen.apellido}</b></h5>
                                                        <h5><b>DIRECCION:</b> {gen.direccion}</h5>
                                                        <h5><b>CELULAR:</b> {gen.celular}</h5>
                                                        <h5><b>EMAIL:</b> {gen.email}</h5>
                                                        <h5><b>NIT:</b> {gen.nit}</h5>
                                                    </div>
                                                    <div className="col-sm-2">

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                            )}
                        </div>

                    </div>
                </main>
            </Welcome>
        )
    }
}
export default MisContactos;
